// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapillary-panel[data-v-9a5356b0]{margin-right:5px;pointer-events:auto}.mapillary-btn[data-v-9a5356b0]{background-color:grey;color:#fff;border-radius:20px}.active-btn[data-v-9a5356b0]{background-color:#03b852}", ""]);
// Exports
module.exports = exports;
